import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_BASE_URL } from './api-config';

export interface UnreadNotificationCountDto {
  count: number;
}

/** Backs the header's notification-bell badge (docs/design/03_api_contracts.md §5, added 2026-08-04). */
@Injectable({ providedIn: 'root' })
export class NotificationInboxService {
  constructor(private http: HttpClient) {}

  getUnreadCount(): Observable<UnreadNotificationCountDto> {
    return this.http.get<UnreadNotificationCountDto>(`${API_BASE_URL}/users/me/notifications/unread-count`);
  }

  markAllRead(): Observable<void> {
    return this.http.post<void>(`${API_BASE_URL}/users/me/notifications/mark-all-read`, null);
  }
}
